import React from 'react';

import WsIconProps from './IconProps';

const Broadcast: React.FC<WsIconProps> = ({ color = '#616893', width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 5C3 3.34315 4.34315 2 6 2H11.5858C12.1162 2 12.6249 2.21071 13 2.58579L17.7071 7.29289C18.0976 7.68342 18.0976 8.31658 17.7071 8.70711C17.4478 8.96645 17.0814 9.05357 16.7502 8.96845C16.6702 8.98905 16.5864 9 16.5 9H13C11.3431 9 10 7.65685 10 6V4H6C5.44772 4 5 4.44772 5 5V19C5 19.5523 5.44772 20 6 20H12C12.5523 20 13 20.4477 13 21C13 21.5523 12.5523 22 12 22H6C4.34315 22 3 20.6569 3 19V5ZM12 4.41421V6C12 6.55228 12.4477 7 13 7H14.5858L12 4.41421ZM18 14C18.5523 14 19 13.5523 19 13C19 12.4477 18.5523 12 18 12C17.4477 12 17 12.4477 17 13C17 13.5523 17.4477 14 18 14ZM21 13C21 14.1967 20.2994 15.2297 19.2859 15.7112C20.8642 16.2467 22 17.7407 22 19.5V21C22 21.5523 21.5523 22 21 22C20.4477 22 20 21.5523 20 21V19.5C20 18.3954 19.1046 17.5 18 17.5C16.8954 17.5 16 18.3954 16 19.5V21C16 21.5523 15.5523 22 15 22C14.4477 22 14 21.5523 14 21V19.5C14 17.7407 15.1358 16.2467 16.7141 15.7112C15.7006 15.2297 15 14.1967 15 13C15 11.3431 16.3431 10 18 10C19.6569 10 21 11.3431 21 13ZM8 8C7.44772 8 7 8.44772 7 9C7 9.55228 7.44772 10 8 10H9C9.55228 10 10 9.55228 10 9C10 8.44772 9.55228 8 9 8H8ZM7 17C7 16.4477 7.44772 16 8 16H10C10.5523 16 11 16.4477 11 17C11 17.5523 10.5523 18 10 18H8C7.44772 18 7 17.5523 7 17ZM8 12C7.44772 12 7 12.4477 7 13C7 13.5523 7.44772 14 8 14H12C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12H8Z"
      fill={color}
    />
  </svg>
);

export default Broadcast;
